import * as React from 'react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';

export interface TabWidgetProps {
  className?: any;
  tabs: string[];
  selected: string;
  onChange: (selected: string) => any;
}

export const TabWidget: React.FC<TabWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      {props.tabs.map((t) => {
        return (
          <S.TabWrapper
            key={t}
            onClick={() => {
              if (props.selected !== t) {
                props.onChange(t);
              }
            }}
          >
            <S.Tab selected={t === props.selected}>{t}</S.Tab>
          </S.TabWrapper>
        );
      })}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    display: flex;
    align-items: center;
  `;

  export const TabWrapper = styled.div`
    padding: 5px 10px;
    &:first-of-type {
      padding-left: 0;
    }
    &:last-of-type {
      padding-right: 0;
    }
  `;

  export const Tab = styled.div<{ selected: boolean }>`
    font-family: ${Font.Special};
    color: ${(p) => p.theme.text.primary};
    padding-bottom: 3px;
    font-size: 16px;
    border-bottom: solid 4px ${(p) => (p.selected ? p.theme.button_primary.background : 'transparent')};
    cursor: pointer;
  `;
}
